/**
* Timeline JS
* -----------------------------------------------------------------------------
*
* All the JS for the Timeline component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'timeline',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.timeline' ).each( function() {
        if ( window.innerWidth > 768 ) {
          let sliderHeight = 0;
          $( '.timeline-slide' ).each( function() {
            sliderHeight = sliderHeight + $( this ).height();
          } );
          $( '.timeline-container' ).height( sliderHeight );
          $( '.timeline-container' ).css( {'display': 'flex', 'flex-direction': 'column'} );
          const docStyle = getComputedStyle( document.documentElement );
          const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
          const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
          const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );
          const progBar = gsap.utils.toArray( '.progress-bar-inner' );
          gsap.from( progBar, {
            height: 0,
            ease: 'linear',
            stagger: {
              each: 0.5,
              onStart: function( ) {
                $( this.targets()[0].nextElementSibling ).css( {borderColor: '#00A638'} );
              },
              onReverseComplete: function() {
                $( this.targets()[0].nextElementSibling ).css( {borderColor: 'white'} );
              },
            },
            scrollTrigger: {
              trigger: '.timeline',
              start: 'top top+=' + topOffset + 'px',
              scrub: true,
              end: 'bottom bottom',
            },
          } );
        } else {
          const progBar = gsap.utils.toArray( '.progress-bar-inner' );
          gsap.from( progBar, {
            height: 0,
            ease: 'none',
            stagger: {
              each: 0.5,
              onStart: function( ) {
                $( this.targets()[0].nextElementSibling ).css( {borderColor: '#00A638'} );
              },
              onReverseComplete: function() {
                $( this.targets()[0].nextElementSibling ).css( {borderColor: 'white'} );
              },
            },
            scrollTrigger: {
              trigger: '.timeline',
              start: 'top top',
              end: 'bottom bottom',
              pin: false,
              scrub: 2,
            },
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'timeline', COMPONENT );
} )( app );
